export default "__VITE_ASSET__5BbzhDYm__"